import moment from "moment-timezone";

export const validationHygieneStatusForm = (formValues) => {
  let errors = {};

  if (!formValues.statusName) {
    errors.statusName = "required!";
  }

  if (!formValues.statusColor) {
    errors.statusColor = "required!";
  }

  return errors;
};

export const validationHygieneTaskFrequencyForm = (formValues) => {
  let errors = {};

  const frequencyCategory = formValues.selectedTaskFrequencyName?.value || "";

  if (!formValues.selectedTaskFrequencyName) {
    errors.selectedTaskFrequencyName = "required!";
  }

  if (
    frequencyCategory === "weekly" &&
    formValues.frequencyDays?.length === 0
  ) {
    errors.frequencyDays = "required!";
  }

  if (
    (frequencyCategory === "monthly" || frequencyCategory === "yearly") &&
    !formValues.frequencyDate
  ) {
    errors.frequencyDate = "required!";
  } else if (
    formValues.frequencyDate &&
    new Date(formValues.frequencyDate) < new Date().setHours(0, 0, 0, 0)
  ) {
    errors.frequencyDate = "Date cannot be in the past!";
  }

  if (
    frequencyCategory === "daily_hourly" &&
    !formValues.selectedFrequencyInterval
  ) {
    errors.selectedFrequencyInterval = "required!";
  }

  if (frequencyCategory === "yearly" && !formValues.selectedMonth) {
    errors.selectedMonth = "required!";
  }

  if (frequencyCategory === "daily_onetime" && !formValues.startTime) {
    errors.startTime = "required!";
  }

  if (frequencyCategory === "daily_onetime" && !formValues.endTime) {
    errors.endTime = "required!";
  }

  return errors;
};

export const validationHygieneNewTaskForm = (formValues) => {
  let errors = {};
  const now = moment.tz("Asia/Kolkata");
  // const todayStr = now.format("YYYY-MM-DD");

  if (!formValues.taskName) {
    errors.taskName = "required!";
  }

  if (!formValues.taskDescription) {
    errors.taskDescription = "required!";
  }

  if (!formValues.selectedHygineCategory) {
    errors.selectedHygineCategory = "required!";
  }

  if (!formValues.selectedTaskPriority) {
    errors.selectedTaskPriority = "required!";
  }

  if (formValues.isImage && !formValues.imageQuantity) {
    errors.imageQuantity = "required!";
  } else if (formValues.isImage && parseInt(formValues.imageQuantity) < 1) {
    errors.imageQuantity = "Minimum 1 image is required!";
  }

  if (formValues.isVideo && !formValues.videoQuantity) {
    errors.videoQuantity = "required!";
  } else if (formValues.isVideo && parseInt(formValues.videoQuantity) < 1) {
    errors.videoQuantity = "Minimum 1 video is required!";
  }

  if (formValues.selectedAccountTypes?.length === 0) {
    errors.selectedAccountTypes = "required!";
  }

  const frequencyCategory = formValues.selectedTaskFrequencyName?.value || "";

  if (!formValues.selectedTaskFrequencyName) {
    errors.selectedTaskFrequencyName = "required!";
  }

  if (!formValues.scheduleDate) {
    errors.scheduleDate = "required!";
  } else if (
    moment.tz(formValues.scheduleDate, "Asia/Kolkata").isBefore(now, "day")
  ) {
    errors.scheduleDate = "Date cannot be in the past!";
  }

  if (
    frequencyCategory === "weekly" &&
    formValues.frequencyDays?.length === 0
  ) {
    errors.frequencyDays = "required!";
  }

  // Add validation for incremental_value and end_after (Repeat Every and End After)
  if (
    frequencyCategory &&
    frequencyCategory !== "no_repeat" &&
    frequencyCategory !== "custom"
  ) {
    if (!formValues.selectedRepeatEvery) {
      errors.selectedRepeatEvery = "Repeat every is required!";
    }
    if (!formValues.selectedEndAfterTimes) {
      errors.selectedEndAfterTimes = "End after is required!";
    }
  }

  // Validate monthly date range for monthly frequency
  if (frequencyCategory === "monthly") {
    if (!formValues.monthlyRangeStart) {
      errors.monthlyRangeStart = "Start date is required!";
    }
    if (!formValues.monthlyRangeEnd) {
      errors.monthlyRangeStart = "End date is required!";
    }
    if (
      formValues.monthlyRangeStart &&
      formValues.monthlyRangeEnd &&
      formValues.monthlyRangeEnd < formValues.monthlyRangeStart
    ) {
      errors.monthlyRangeStart = "End date must be after start date!";
    }
    // Check if both dates are from the same month
    if (formValues.monthlyRangeStart && formValues.monthlyRangeEnd) {
      const startDate = moment.tz(formValues.monthlyRangeStart, "Asia/Kolkata");
      const endDate = moment.tz(formValues.monthlyRangeEnd, "Asia/Kolkata");

      if (startDate.month() !== endDate.month() || startDate.year() !== endDate.year()) {
        errors.monthlyRangeStart = "Both dates must be from the same month!";
      }
    }
  }

  // Validate time slots for all non-custom frequency types
  if (frequencyCategory !== "custom") {
    if (
      !Array.isArray(formValues.timeSlots) ||
      formValues.timeSlots.length === 0
    ) {
      errors.timeSlots = "At least one time slot is required";
    } else {
      formValues.timeSlots.forEach((slot, idx) => {
        if (!slot.startTime || !slot.endTime) {
          if (!errors.timeSlots) errors.timeSlots = {};
          errors.timeSlots[idx] = "Start and End time required";
        } else {
          if (
            moment
              .tz(slot.endTime, "HH:mm", "Asia/Kolkata")
              .isSameOrBefore(moment.tz(slot.startTime, "HH:mm", "Asia/Kolkata"))
          ) {
            if (!errors.timeSlots) errors.timeSlots = {};
            errors.timeSlots[idx] = "End time must be after start time";
          }
        }
      });
    }
  }

  if (formValues.selectedTaskFrequencyName?.value === "custom") {
    if (
      !Array.isArray(formValues.customDates) ||
      formValues.customDates.length === 0
    ) {
      errors.customDates = "At least one custom date/time is required";
    } else {
      formValues.customDates.forEach((item, idx) => {
        if (!item.date || !item.startTime || !item.endTime) {
          if (!errors.customDates) errors.customDates = {};
          errors.customDates[idx] = "Date, Start and End time required";
        } else {
          if (moment.tz(item.date, "Asia/Kolkata").isBefore(now, "day")) {
            if (!errors.customDates) errors.customDates = {};
            errors.customDates[idx] = "Date cannot be in the past";
          }
          if (
            moment
              .tz(item.endTime, "HH:mm", "Asia/Kolkata")
              .isSameOrBefore(
                moment.tz(item.startTime, "HH:mm", "Asia/Kolkata")
              )
          ) {
            if (!errors.customDates) errors.customDates = {};
            errors.customDates[idx] = "End time must be after start time";
          }
          if (moment.tz(item.date, "Asia/Kolkata").isSame(now, "day")) {
            const nowTime = now.format("HH:mm");
            if (
              moment
                .tz(item.endTime, "HH:mm", "Asia/Kolkata")
                .isBefore(moment.tz(nowTime, "HH:mm", "Asia/Kolkata")) &&
              moment
                .tz(item.startTime, "HH:mm", "Asia/Kolkata")
                .isBefore(moment.tz(nowTime, "HH:mm", "Asia/Kolkata"))
            ) {
              if (!errors.customDates) errors.customDates = {};
              errors.customDates[idx] =
                "Time range is already passed for today";
            }
          }
        }
      });
    }
  }

  return errors;
};

export const validationHygieneTaskForm = (formValues) => {
  let errors = {};

  if (!formValues.selTaskCat) {
    errors.selTaskCat = "required!";
  }

  if (!formValues.taskName) {
    errors.taskName = "required!";
  }

  if (!formValues.taskDescription) {
    errors.taskDescription = "required!";
  } else if (
    formValues.taskDescription &&
    formValues.taskDescription?.length > 100
  ) {
    errors.taskDescription = "required!";
  }

  if (!formValues.selTaskInterval) {
    errors.selTaskInterval = "required!";
  }

  if (!formValues.taskInterval) {
    errors.taskInterval = "required!";
  }

  if (!formValues.selMediaType) {
    errors.selMediaType = "required!";
  }

  if (!formValues.noOfMediaRequired) {
    errors.noOfMediaRequired = "required!";
  }

  if (!formValues.selAssignee) {
    errors.selAssignee = "required!";
  }

  if (
    formValues.selTaskInterval?.value === "week" &&
    formValues.checkedWeeks?.length === 0
  ) {
    errors.checkedWeeks = "required!";
  }

  if (!formValues.startTime) {
    errors.startTime = "required!";
  }

  if (!formValues.endTime) {
    errors.endTime = "required!";
  }

  return errors;
};

export const validationHygieneTaskCategoryForm = (formValues) => {
  let errors = {};

  if (!formValues.categoryName) {
    errors.categoryName = "required!";
  }

  return errors;
};
